module.exports = __webpack_public_path__ + "static/media/office_nn_tablet.29f4dd98.jpg";